import * as api from '@/api'
import * as types from '../mutation-types'

// initial state
const state = {
  all: ['', '', '', '', '', '', '', ''],
  loading: false,
  count: 6
}

// mutations
const mutations = {
  [types.RECEIVE_PRODUCTS] (state, products) {
    state.all = products
    state.count = products.reduce((acc, product) => {
      if (product.siblingList) {
        return acc + product.siblingList.length
      }
      return acc + 1
    }, 0)
  },
  [types.LOADING_PRODUCTS] (state, loading) {
    state.loading = loading
  }
}

const getters = {
  getAllProducts: function () {
    return state.all
  },
  isLoading: function () {
    return state.loading
  },
  productCount: function () {
    return state.count
  }
}

const actions = {
  fetchAllProducts: (store) => {
    const productList = ['Jacques', 'Claude', 'Lily']
    store.commit(types.RECEIVE_PRODUCTS, productList)
  },
  getProducts: (store) => {
    store.commit(types.LOADING_PRODUCTS, true)

    document.body.classList.toggle('theme-christmas', location.href.includes('christmas'))

    api.fetchProducts(store.getters.selectedFilters, productList => {
      store.commit(types.LOADING_PRODUCTS, false)
      store.commit(types.RECEIVE_PRODUCTS, productList)
    })
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/products.js